import React, { useState } from "react";
import MainCalculatorsList from "./MainCalculators";
import SharedHelmet from ".././Helmet";
import RelatedLinks from "../RelatedLinks";
import { FirstAds, SecondAds, MobileUnderCalAds } from "../../Ads";

const TITLE = "Calculatrice de temps d'arrivée - Calculez le temps d'arrivée en fonction de la vitesse et de la distance";
const DESCRIPTION =
  "Calculatrice de temps d'arrivée - Calculez le temps d'arrivée en fonction de la vitesse et de la distance. Calculateur de physique en francais avec resultat rapide, unites claires et aide pratique pour exercices et revisions.";
const KEYWORDS =
  "arrival time, calculatrice physique, formule physique, exercices de physique, calcul en ligne";
const OG_URL = "https://do-calculate.com/calculator/fr/arrivaltime";

function ArrivalTimeCalculator() {
  const [distance, setDistance] = useState("");
  const [speed, setSpeed] = useState("");
  const [arrivalTime, setArrivalTime] = useState("");
  const [error, setError] = useState("");

  const handleCalculate = () => {
    if (!distance || !speed) {
      setError("Veuillez entrer la distance et la vitesse correctement");
      setArrivalTime("");
      return;
    }

    const distanceValue = parseFloat(distance);
    const speedValue = parseFloat(speed);

    if (isNaN(distanceValue) || isNaN(speedValue) || speedValue <= 0) {
      setError("Veuillez entrer des valeurs correctes et positives pour la distance et la vitesse");
      setArrivalTime("");
      return;
    }

    const arrivalTimeValue = distanceValue / speedValue;
    setArrivalTime(arrivalTimeValue.toFixed(2));
    setError("");
  };

  return (
    <div className="ltr">
      <SharedHelmet
        TITLE={TITLE}
        DESCRIPTION={DESCRIPTION}
        KEYWORDS={KEYWORDS}
        OG_URL={OG_URL}
      />
      <div className="row">
        <div className="col-12 col-md-8">
          <FirstAds />
        </div>
      </div>
      <div className="row">
        <div className="col-12 col-md-8">
          <br />
          <div
            className="bg-success text-white text-center"
            style={{ height: "50px" }}
          >
            <h1 style={{ fontSize: "17px" }}>{TITLE}</h1>
          </div>
          <div className="border border-light">
            <div className="row">
              <div>
                <p>
                  Pour calculer le temps d'arrivée, nous avons besoin de connaître la distance à parcourir et la vitesse à laquelle l'objet se déplace.
                </p>
                <p>
                  Nous pouvons calculer le temps d'arrivée d'une personne ou d'un camion ou d'une voiture ou d'un train ou de tout objet en mouvement en déterminant la vitesse à laquelle cet objet se déplace, qu'il s'agisse d'une personne ou d'un véhicule, et en calculant et connaissant la distance qui sera couverte par cet objet, et lorsque nous calculons la vitesse à laquelle l'objet peut se déplacer et la distance parcourue, nous pouvons calculer le temps comme suit:
                </p>
                <p>
                  <b>Temps = Distance parcourue / Vitesse de l'objet</b>
                </p>
                <p>
                  En connaissant le temps que l'objet prend pour arriver, nous pouvons savoir à quel moment exact l'objet arrivera au point désiré.
                </p>
                <p>
                  Utilisez la calculatrice suivante pour calculer le temps d'arrivée en fonction de la vitesse et de la distance
                </p>
                <hr />
              </div>
            </div>
            <MobileUnderCalAds />
            <div className="row">
              <div className="col-sm-12 col-md-7 calculatorStyle">
                <div className="p-3 mb-2 bg-success text-white">
                  <h2 style={{ fontSize: "16px" }}>{TITLE} </h2>
                </div>
                <hr />
                <div dir="ltr">
                  <div>
                    <div className="form-group d-flex align-items-center">
                      <b>
                        <label className="form-label ms-2">
                          Distance (kilomètre)
                        </label>
                      </b>
                      <input
                        type="number"
                        placeholder="80"
                        value={distance}
                        onChange={(e) => setDistance(e.target.value)}
                        className="form-control"
                        style={{ width: "90%" }}
                      />
                    </div>
                    <br />
                    <div className="form-group d-flex align-items-center">
                      <b>
                        <label className="form-label ms-2">
                          Vitesse (kilomètre/heure)
                        </label>
                      </b>
                      <input
                        type="number"
                        placeholder="8"
                        value={speed}
                        onChange={(e) => setSpeed(e.target.value)}
                        className="form-control"
                        style={{ width: "90%" }}
                      />
                    </div>
                    <br />
                    <button
                      className="btn btn-success"
                      style={{ fontSize: "20px" }}
                      onClick={handleCalculate}
                    >
                      Calculer le temps d'arrivée
                    </button>
                  </div>
                  <br />
                  <div>
                    {error !== "" ? (
                      <p className="p-3 mb-2 bg-warning text-white">
                        Erreur: {error}
                      </p>
                    ) : (
                      <>
                        {arrivalTime !== "" && (
                          <>
                            <p className="p-3 mb-2 bg-success text-white">
                              Temps d'arrivée (heure): {arrivalTime} heure
                            </p>
                            <p className="p-3 mb-2 bg-info text-black">
                              Étapes de la solution: <br />- Calculez le temps en vous basant sur la loi suivante: Temps (heure) = Distance (kilomètre) / Vitesse (kilomètre/heure) - Divisez ensuite la distance à parcourir par la vitesse pour obtenir le temps final.
                            </p>
                          </>
                        )}
                      </>
                    )}
                  </div>
                </div>
              </div>
            </div>
            <hr />
            <div className="row">
              <RelatedLinks />
              <hr />
            </div>
          </div>
        </div>
        <div className="col">
          <SecondAds />
          <br />
          <MainCalculatorsList></MainCalculatorsList>
          <br />
        </div>
      </div>
    </div>
  );
}

export default ArrivalTimeCalculator;
